import React, { useEffect, useState } from 'react';
import './careers.css';
import { nrError } from 'helpers/reporting/newrelic';

const LEVER_POSTINGS_URL = 'https://api.lever.co/v0/postings/artifactuprising.com';

export interface JobPosting {
  additionalPlain: string;
  additional: string;
  categories: {
    commitment: string;
    location: string;
    team: string;
    allLocations: string[];
  };
  createdAt: number;
  descriptionPlain: string;
  description: string;
  id: string;
  lists: {
    text: string;
    content: string;
  }[];
  salaryRange: {
    min: number;
    max: number;
    currency: string;
    interval: string;
  };
  text: string;
  country: string;
  workplaceType: string;
  opening: string;
  openingPlain: string;
  descriptionBody: string;
  descriptionBodyPlain: string;
  hostedUrl: string;
  applyUrl: string;
}

const Careers = (): JSX.Element => {
  const [jobs, setJobs] = useState<JobPosting[]>([]);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch(LEVER_POSTINGS_URL);
        const data = await response.json();
        setJobs(data);
      } catch (error) {
        nrError('Lever Error', error, error);
      }
    };
    void fetchJobs();
  }, []);

  return (
    <div className="careers">
      <h3 className="table-title">OPEN POSITIONS</h3>
      {jobs.length > 0 ? (
        <table className="career-table">
          <tbody>
          {jobs.map((job) => (
            <tr className="job-row" key={job.id}>
              <td className="job-title">{job.text}</td>
              <td className="job">THE JOB</td>
              <td className="job-description">
                <div>{job.descriptionPlain}</div>
                <a
                  href={job.hostedUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="read-more"
                >
                  READ MORE
                </a>
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      ) : (
        <p className="no-jobs">Thanks so much for your interest in joining our team. While we do not have any open roles
          at this time, please check back for future opportunities.</p>
      )}
    </div>
  );
};

export default Careers;
